<template>
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 2.14648H6C4.34315 2.14648 3 3.48963 3 5.14648V10.1465C3 11.8033 4.34315 13.1465 6 13.1465H11C12.6569 13.1465 14 11.8033 14 10.1465V7.64648" stroke="#E87318" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M13.5 2L9.52144 6.377" stroke="#E87318" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M7.28236 9.33205C6.91058 9.43167 6.57037 9.09147 6.66999 8.71968L7.6088 5.21598C7.70842 4.8442 8.17315 4.71967 8.44532 4.99184L11.0102 7.55672C11.2824 7.82889 11.1578 8.29362 10.7861 8.39324L7.28236 9.33205Z" fill="#E87318"/>
    </svg>
</template>

<script>
export default {
    name: 'import-icon'
}
</script>
